import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HRRoutingModule } from './hr-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, TimepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SalaryComponentComponent } from './salary-component/salary-component.component';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';
import { EmployeeSalaryMappingComponent } from './employee-salary-mapping/employee-salary-mapping.component';
import { DailyAttendanceStaffComponent } from './daily-attendance-staff/daily-attendance-staff.component';
import { MonthlyAttendanceStaffComponent } from './monthly-attendance-staff/monthly-attendance-staff.component';
import { StaffAttendanceSummaryComponent } from './staff-attendance-summary/staff-attendance-summary.component';
import { StaffAllowancesComponent } from './staff-allowances/staff-allowances.component';
import { EmployeeAdvanceComponent } from './employee-advance/employee-advance.component';
import { SalaryCalculationComponent } from './salary-calculation/salary-calculation.component';
import { SalaryPrintComponent } from './salary-print/salary-print.component';
import { SalaryListPrintComponent } from './salary-list-print/salary-list-print.component';
import { StaffTimeAttendanceComponent } from './monthly-attendance/staff-time-attendance.component';
import { ShiftComponent } from './shift/shift.component';
import { StaffShiftMappingComponent } from './staff-shift-mapping/staff-shift-mapping.component';
import { SalaryMonthComponent } from './salary-month/salary-month.component';
import { EmployeeShiftMappingComponent } from './employee-shift-mapping/employee-shift-mapping.component';
import { DailyAttendancePrintComponent } from './daily-attendance-print/daily-attendance-print.component';
import { MonthlyAttendancePrintComponent } from './monthly-attendance-print/monthly-attendance-print.component';
import { StaffAttendanceSummaryPrintComponent } from './staff-attendance-summary-print/staff-attendance-summary-print.component';
import { MonthlyAttendanceStaffPrintComponent } from './monthly-attendance-staff-print/monthly-attendance-staff-print.component';


@NgModule({
  declarations: [SalaryComponentComponent,PaymentModeComponent, EmployeeSalaryMappingComponent, 
      DailyAttendanceStaffComponent, MonthlyAttendanceStaffComponent, StaffAttendanceSummaryComponent,
       StaffAllowancesComponent, EmployeeAdvanceComponent,SalaryCalculationComponent,SalaryPrintComponent,
        SalaryListPrintComponent,StaffTimeAttendanceComponent, ShiftComponent, 
        StaffShiftMappingComponent, SalaryMonthComponent,EmployeeShiftMappingComponent, 
        DailyAttendancePrintComponent,MonthlyAttendancePrintComponent, StaffAttendanceSummaryPrintComponent, 
        MonthlyAttendanceStaffPrintComponent],
        
  imports: [
    CommonModule,
    HRRoutingModule, 
    AdminModule,   
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TimepickerModule.forRoot(),
    
  ]
})
export class HRModule { }
